
import { Component, Vue } from "vue-property-decorator";
// import { objAny } from "@/common/common-interface";
@Component
export default class InfoTitle extends Vue {}
